var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-content-wrapper"},[_c('v-data-table',{staticClass:"point-history-table",attrs:{"hide-default-footer":true,"headers":_vm.headers,"items":_vm.history},scopedSlots:_vm._u([{key:"item.created_at",fn:function({ item }){return [_vm._v("\n\t\t\t"+_vm._s(_vm._f("moment")(item.created_at,"DD/MM/YY @ H:mm"))+"\n\t\t")]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }